import {NgModule, Component, Injectable} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
// 
import {ReactiveFormsModule, FormControl, FormsModule} from '@angular/forms';
import {Observable, map, debounceTime,distinctUntilChanged, switchMap, delay } from 'rxjs';
// 
// import 'rxjs/add/operator/debounceTime';
// import 'rxjs/add/operator/distinctUntilChanged';
// import 'rxjs/add/operator/switchMap';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/delay';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JobSubjectServiceType } from  './../shared/models/jobSubjectServiceType.model';
import { Router } from '@angular/router';
import { JobSubject } from './../shared/models/jobSubject.model';

import {HttpClientModule} from '@angular/common/http'
// import {HttpClient} from '@angular/common/http'

// import { Trace } from './../api/trace';

import { GlobalFunctionsService } from './../services/global-functions.service';
import { DataUtil } from '@syncfusion/ej2-data';
// import { CorporateMembers } from './../api/corporate-members';





class SearchItem {
    constructor(public track: string,
                public artist: string,
                public link: string,
                public thumbnail: string,
                public artistId: string) {
    }
  }


class SearchJobSubjects {
  constructor(
    public subject_id?: number,
    public job_id?: number,
    public subject_number?: string,
    public first_name?: string,
    public middle_name?: string,
    public surname?: string,
    public title?: string,
    public is_active?: string,
    public next_date?: any,
    public final_date?: any,
    public job_status_id?: number,
    public street_address?: string,
    public suburb?: string,
    public state?: string,
    public  postcode?: string,
    public phone_h?: string,
    public email?: string,
    public dob?: string,
    public phone_m?: string,
    public subject_type_id?: number,
    public file_number?: string,
    public special_instructions?: string,
    public job_status?: string,
    public reference_number?: string,
    public job_reference_number?: string,
    public created_by?: number,
    public created_date?: string,
    public updated_date?: string,
    public updated_by?: number,
    public completed_date?: string,
    public completed_by?: string,
    public start_date?: string,
    public started_by?: string,
    public time_taken?: string,
    public sex?: string,
    public finalised?: string,
    public subject_reference_created?: string,
    public brand_report_user_id?: number,
    public job_type_id?: number,
    public job_type_location_id?: number,
    public job_type_court_id?: number,
    public job_type_document_type_id?: number,
    public job_type_affidavit_type_id?: number,
    public business_name?: string,
    public prev_subject_id?: number,
    public next_subject_id?: number,
    public number_subjects?: number,
    public existing_subjects_count?: number,
    public job_subject_type_id?: number,
    public subject_report_order_number?: number,
    public job_service_rule_id?: number,
    public job_service_timeframe_id?: number,
    public subject_service_type_id?: number,
    public service_company_name?: string,
    public service_directors_name?: string,
    public service_prison_name?: string,
    public service_law_firm_name?: string,
    public service_solicitor_name?: string,
    public owner_trace_code?: string,
    public subject_name?: string,
    public job_number?: string,

     public timeframe_surcharge_colour?: string,
      public timeframe_surcharge_id?: number,
       public timeframe_surcharge_icon?: string,
        public timeframe_surcharge_name?: string,
        public search_match_label?: string,
        public search_match_value?: string,


  ) {  }
}


  class SearchCorporateMembers {
    constructor (public cpm_id: number,
      public cpm_roleid: number,
      public cpm_membername: string,
      public cpm_website: string,
      public cpm_service: string,
      public cpm_addby: number,
      public cpm_adddate: string,
      public cpm_modifyby: number,
      public cpm_modifydate: string,
      public isactive: number ) {}
  }





class SearchTrace {
  constructor (
    public trace_id: number,
    public trace_number: string,
    public brand_id: number,
    public client_company_name: string,
    public client_name: string,
    public client_phone: string,
    public special_instructions: any,
    public report_type_id: number,
    public client_client_id: number,
    public updated_by: number,
    public created_date: string,
    public creatded_by: number,
    public created_by: number,
    public owner_trace_code: string,
    public updated_date: number,
      // Advanced Fields // Dev Tools
      public project_type: number,
      public allocated_date: string,
      public allocated_to: number,
      public allocated_by: number,
      public status: number,
      public progress_percentage: number,
      public locate_status: number,
      public total_candidates_count: number,
      public completed_candidates_count: number,
      public completed_date: string,
      public trace_api_key: string,

      // additional fields for statistics and trackings upgrade
public pl_count: number,
public l_count: number,
public nl_count: number,
public fee: number,
public adverage_trace_time: number,
public total_open: number,
public total_all: number,
public total_all_all: number,
public pl_percent: number,
public l_percent: number,
public nl_percent: number,
public completed_by: number,
public start_date: string,
public started_by: number,
public time_taken: number,


 public sex?: string,
    public finalised?: string,
    public subject_reference_created?: string,
    public brand_report_user_id?: number,
    public job_type_id?: number,
    public job_type_location_id?: number,
    public job_type_court_id?: number,
    public job_type_document_type_id?: number,
    public job_type_affidavit_type_id?: number,
    public business_name?: string,
    public prev_subject_id?: number,
    public next_subject_id?: number,
    public number_subjects?: number,
    public existing_subjects_count?: number,
    public job_subject_type_id?: number,
    public subject_report_order_number?: number,
    public job_service_rule_id?: number,
    public job_service_timeframe_id?: number,
    public subject_service_type_id?: number,
    public service_company_name?: string,
    public service_directors_name?: string,
    public service_prison_name?: string,
    public service_law_firm_name?: string,
    public service_solicitor_name?: string,

    public subject_name?: string,
    public job_number?: string,

     public timeframe_surcharge_colour?: string,
      public timeframe_surcharge_id?: number,
       public timeframe_surcharge_icon?: string,
        public timeframe_surcharge_name?: string,

) {}
}


class SearchTraceCandidate {
  constructor(
    public trace_candidate_id: number,
    public candidate_firstname: string,
    public candidate_middlename: string,
    public candidate_surname: string,
    public candidate_dob_provided: string,
    public trace_id: number,
    public report_id: number,
    public owner_trace_code: string,
    public candidate_trace_number: string,
    public candidate_file_code: string,
    public special_instructions: string,
    public report_type_id: number,
    public updated_date: string,
    public updated_by: number,
    public created_date: string,
    public created_by: number,
    public allocated_date: string,
    public allocated_to: number,
    public allocated_by: number,
    public status: string,
    public progress_percentage: number,
    public locate_status: number,
    public total_candidates_count: number,
    public completed_candidates_count: number,
    public completed_date: string,
    public trace_api_key: string,
    public trace_number: number,
    public candidate_email: string,
    public brand_id: number,
    public completed_by: number,
    public client_client_id: number,
    public candidate_address: string,
    public start_date: any,
    public started_by: number,
    public time_taken: number,
  )
  {}
}


@Injectable()
export class SearchService {


    apiRoot = 'https://itunes.apple.com/search';

    apiRootCM = 'http://new.aihe.com.au/APP_PHP/search_corporate_members.php';
    apiRootT = this.gfunc.apiURL + '/api/trace/search';
    apiRootTC = this.gfunc.apiURL + '/api/trace/search/candidates';
    ///api/trace/searchClientFilter/candidates/{term}/{limit}/{brand_id}/{date_a}/{date_b}
    apiRootTCBrand = this.gfunc.apiURL + '/api/trace/searchClientFilter/candidates';
    apiRootTBrand = this.gfunc.apiURL + '/api/trace/searchClientFilter'; // all this still works and is active (I changed rest to SOP for Launch)
    apiRootS = this.gfunc.apiURL + '/api/trace/searchClientFilter';
    apiRootTStaff = this.gfunc.apiURL + '/api/trace/searchStaffFilter';
    apiRootTCStaff = this.gfunc.apiURL + '/api/trace/searchStaffFilter/candidates';

// /api/trace/searchClientFilter/{term}/{limit}/{brand_id}/{date_a}/{date_b}
// all jobs and subjects jon quiery no fulters.
apiRootJobSubjects = this.gfunc.apiURL + '/api/job/subject/search'; // NOTE USING OLD SERVER!!

apiRootJobSubjects_Global = this.gfunc.apiURL + '/api/job/subject/global/search';



subject_model: JobSubject;
// apiRootTBrand = 'http://sop.nickbowen.com.au/api/trace/searchClientFilter';

// need to write the SQL!

  constructor(public _http: HttpClient, public http: HttpClient,
   public gfunc: GlobalFunctionsService
    ) {

      this.subject_model = new JobSubject();
  }


/**/
  search(term: string): Observable<SearchItem[]> {
    const apiURL = `${this.apiRoot}?term=${term}&media=music&limit=20`;
    return this._http.get(apiURL)
        .pipe(map(res => {
          return res[0].json().results.map(item => {
            return new SearchItem(
                item.trackName,
                item.artistName,
                item.trackViewUrl,
                item.artworkUrl30,
                item.artistId
            );
          });
        }));
  }



  // ...model

  // searchJS_OLD(term: string): Observable<SearchJobSubjects[]> {
  //   const apiJS = `${this.apiRootJobSubjects}/${term}/999`;
  //   return this._http.get(apiJS)
  //       .map(res => {
  //         return res.json().map( js => {
  //           return new SearchJobSubjects(
  //               js.job_number,
  //               js.subject_number,
  //               js.job_id,
  //               js.subject_id,
  //               js.first_name,
  //               js.middle_name,
  //               js.surname,
  //               js.title,
  //               js.is_active,
  //               js.next_date,
  //               js.final_date,
  //               js.job_status_id,
  //               js.street_address,
  //               js.suburb,
  //               js.state,
  //               js.postcode,
  //               js.phone_h,
  //               js.email,
  //               js.dob,
  //               js.phone_m,
  //               js.subject_type_id,
  //               js.file_number,
  //               js.special_instructions,
  //               js.job_status,
  //               js.reference_number,
  //               js.job_reference_number,
  //               js.created_by,
  //               js.created_date,
  //               js.updated_date,
  //               js.updated_by,
  //               js.completed_date,
  //               js.completed_by,
  //               js.start_date,
  //               js.started_by,
  //               js.time_taken,
  //               js.sex,
  //               js.finalised,
  //               js.subject_reference_created,
  //               js.brand_report_user_id,
  //               js.job_type_id,
  //               js.job_type_location_id,
  //               js.job_type_court_id,
  //               js.job_type_document_type_id,
  //               js.job_type_affidavit_type_id,
  //               js.business_name,
  //               js.prev_subject_id,
  //               js.next_subject_id,
  //               js.number_subjects,
  //               js.existing_subjects_count,
  //               js.subject_report_order_number,
  //               js.job_service_rule_id,
  //               js.job_service_timeframe_id,
  //               js.subject_service_type_id,
  //               js.service_company_name,
  //               js.service_directors_name,
  //               js.service_prison_name,
  //               js.service_law_firm_name,
  //               js.service_solicitor_name,
  //           );
  //         });
  //       });

  // }




/*

    subject_id?: number;
    job_id?: number;
    first_name?: string;
    middle_name?: string;
    surname?: string;
    title?: string;
    is_active?: string;
    next_date?: string;
    final_date?: string;
    job_status_id?: number;
    street_address?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    phone_h?: string;
    email?: string;
    dob?: string;
    phone_m?: string;
    subject_type_id?: number;
    file_number?: string;
    special_instructions?: string;
    job_status?: string;
    reference_number?: string;
    job_reference_number?: string;
    created_by?: number;
    created_date?: string;
    updated_date?: string;
    updated_by?: number;
    completed_date?: string;
    completed_by?: string;
    start_date?: string;
    started_by?: string;
    time_taken?: string;
    sex?: string;
    finalised?: string;
    subject_reference_created?: string;
    brand_report_user_id?: number;
    job_type_id?: number;
    job_type_location_id?: number;
    job_type_court_id?: number;
    job_type_document_type_id?: number;
    job_type_affidavit_type_id?: number;
    business_name?: string;
    prev_subject_id?: number;
    next_subject_id?: number;


    number_subjects?: number;
    existing_subjects_count?: number;

    job_subject_type_id?: number;
    subject_report_order_number?: number;

    job_service_rule_id?: number;
    job_service_timeframe_id?: number;
    subject_service_type_id: number;

    service_company_name?: string;
service_directors_name?: string;
service_prison_name?: string;
service_law_firm_name?: string;
 service_solicitor_name?: string;


*/



/*
  searchCM(term: string): Observable<SearchCorporateMembers[]> {
    const apiURLCM = `${this.apiRootCM}?term=${term}&limit=202`;
    return this._http.get(apiURLCM)
        .map(res => {
          return res.json().map(cm => {
            return new SearchCorporateMembers(
                cm.cpm_id,
                cm.cpm_roleid,
                cm.cpm_membername,
                cm.cpm_website,
                cm.cpm_service,
                cm.cpm_addby,
                cm.cpm_adddate,
                cm.cpm_modifyby,
                cm.cpm_modifydate,
                cm.isactive
            );
          });
        });

  }

*/



  searchCM(term: string): Observable<SearchCorporateMembers[]> {
    const apiURLCM = `${this.apiRootCM}?term=${term}&limit=202`;
    return this._http.get(apiURLCM)
        .pipe(map(res => {
          return res[0].json().map(cm => {
            return new SearchCorporateMembers(
                cm.cpm_id,
                cm.cpm_roleid,
                cm.cpm_membername,
                cm.cpm_website,
                cm.cpm_service,
                cm.cpm_addby,
                cm.cpm_adddate,
                cm.cpm_modifyby,
                cm.cpm_modifydate,
                cm.isactive
            );
          });
        }));

  }




  searchT(term: string): Observable<SearchTrace[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLT = `${this.apiRootT}/${term}/202`;
    return this._http.get(apiURLT)
        .pipe(map(res => {
          return res[0].json().map(t => {
            return new SearchTrace(
                t.trace_id,
                t.trace_number,
                t.brand_id,
                t.client_company_name,
                t.client_name,
                t.client_phone,
                t.special_instructions,
                t.report_type_id,
                t.client_client_id,
                t.updated_by,
                t.created_date,
                t.creatded_by,
                t.created_by,
                t.owner_trace_code,
                t.updated_date,
                t.project_type,
                t.allocated_date,
                t.allocated_to,
                t.allocated_by,
                t.status,
                t.progress_percentage,
                t.locate_status,
                t.total_candidates_count,
                t.completed_candidates_count,
                t.completed_date,
                t.trace_api_key,
                t.pl_count,
                t.l_count,
                t.nl_count,
                t.fee,
                t.adverage_trace_time,
                t.total_open,
                t.total_all,
                t.total_all_all,
                t.pl_percent,
                t.l_percent,
                t.nl_percent,
                t.completed_by,
                t.start_date,
                t.started_by,
                t.time_taken,
                t.timeframe_surcharge_colour,
                t.timeframe_surcharge_id,
                t.timeframe_surcharge_icon,
                t.timeframe_surcharge_name
            );
          });
        }));

  }


  searchJS(term: string, brand_id: number, limit: number = 301): Observable<SearchJobSubjects[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLJS = `${this.apiRootJobSubjects}/${term}/${limit}`;
  
  
  
    // return this.http.get(apiURLJS).pipe(
    //   map(res => {
    //     return res.results.map(item => {
    //       return new SearchItem(
    //         item.trackName,
    //         item.artistName,
    //         item.trackViewUrl,
    //         item.artworkUrl30,
    //         item.artistId
    //       );
    //     });
    //   })
    // );
  
  


  
  
    this.filterSearchResults(this._http.get(apiURLJS));
    return this._http.get(apiURLJS)
        .pipe(map(res => {
          return JSON.parse(JSON.stringify(res)).map(js => {
            return new SearchJobSubjects(
js.subject_id,
js.job_id,
js.subject_number,
js.first_name,
js.middle_name,
js.surname,
js.title,
js.is_active,
js.next_date,
js.final_date,
js.job_status_id,
js.street_address,
js.suburb,
js.state,
js. postcode,
js.phone_h,
js.email,
js.dob,
js.phone_m,
js.subject_type_id,
js.file_number,
js.special_instructions,
js.job_status,
js.reference_number,
js.job_reference_number,
js.created_by,
js.created_date,
js.updated_date,
js.updated_by,
js.completed_date,
js.completed_by,
js.start_date,
js.started_by,
js.time_taken,
js.sex,
js.finalised,
js.subject_reference_created,
js.brand_report_user_id,
js.job_type_id,
js.job_type_location_id,
js.job_type_court_id,
js.job_type_document_type_id,
js.job_type_affidavit_type_id,
js.business_name,
js.prev_subject_id,
js.next_subject_id,
js.number_subjects,
js.existing_subjects_count,
js.job_subject_type_id,
js.subject_report_order_number,
js.job_service_rule_id,
js.job_service_timeframe_id,
js.subject_service_type_id,
js.service_company_name,
js.service_directors_name,
js.service_prison_name,
js.service_law_firm_name,
js.service_solicitor_name,
js.owner_trace_code,
js.subject_name,
js.job_number,
js.timeframe_surcharge_colour,
js.timeframe_surcharge_id,
js.timeframe_surcharge_icon,
js.timeframe_surcharge_name,
js.search_match_label,
js.search_match_value
            );
          });
        }));

  }

// Testing new search for agent dashboard
  searchJS_Agent(term: string, brand_id: number, brand_type_id, job_status_code, assinged_agent): Observable<SearchJobSubjects[]> {
  //  brand_type_id = this.gfunc.sessionBrandTypeId; // set from login values
  //  brand_id = this.gfunc.sessionBrandId;

    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    // tslint:disable-next-line:max-line-length
    const apiURLJS_Agent = `${this.apiRootJobSubjects_Global}/${term}/20002/${brand_type_id}/${brand_id}/${job_status_code}/${assinged_agent}`; // no trailin slash!
    
    // OLD METHOD
    // this.filterSearchResults(this._http.get(apiURLJS_Agent));
    // return this._http.get(apiURLJS_Agent)
    //     .pipe(map(res => {
    //       return res[0].json().map(js => {

    // NEW METHOD
    return this._http.get(apiURLJS_Agent)
    .pipe(map(res => {
      return JSON.parse(JSON.stringify(res)).map(js => {
            return new SearchJobSubjects(
js.subject_id,
js.job_id,
js.subject_number,
js.first_name,
js.middle_name,
js.surname,
js.title,
js.is_active,
js.next_date,
js.final_date,
js.job_status_id,
js.street_address,
js.suburb,
js.state,
js. postcode,
js.phone_h,
js.email,
js.dob,
js.phone_m,
js.subject_type_id,
js.file_number,
js.special_instructions,
js.job_status,
js.reference_number,
js.job_reference_number,
js.created_by,
js.created_date,
js.updated_date,
js.updated_by,
js.completed_date,
js.completed_by,
js.start_date,
js.started_by,
js.time_taken,
js.sex,
js.finalised,
js.subject_reference_created,
js.brand_report_user_id,
js.job_type_id,
js.job_type_location_id,
js.job_type_court_id,
js.job_type_document_type_id,
js.job_type_affidavit_type_id,
js.business_name,
js.prev_subject_id,
js.next_subject_id,
js.number_subjects,
js.existing_subjects_count,
js.job_subject_type_id,
js.subject_report_order_number,
js.job_service_rule_id,
js.job_service_timeframe_id,
js.subject_service_type_id,
js.service_company_name,
js.service_directors_name,
js.service_prison_name,
js.service_law_firm_name,
js.service_solicitor_name,
js.owner_trace_code,
js.subject_name,
js.job_number,
js.timeframe_surcharge_colour,
js.timeframe_surcharge_id,
js.timeframe_surcharge_icon,
js.timeframe_surcharge_name
            );
          });
        }));

  }



  // Testing new search for agent dashboard
  searchJS_Client(term: string, brand_id: number, brand_type_id, job_status_code, assinged_agent): Observable<SearchJobSubjects[]> {
    //  brand_type_id = this.gfunc.sessionBrandTypeId; // set from login values
    //  brand_id = this.gfunc.sessionBrandId;
  
      // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
      // tslint:disable-next-line:max-line-length
      // client can use the same global apiURL just nake the assigned agent = 0 
      const apiURLJS_Client = `${this.apiRootJobSubjects_Global}/${term}/20002/${brand_type_id}/${brand_id}/${job_status_code}/0`; // no trailin slash!
      // this.filterSearchResults(this._http.get(apiURLJS_Client));
      // return this._http.get(apiURLJS_Client)
      //     .pipe(map(res => {
      //       return res[0].json().map(js => {

    // NEW METHOD
    return this._http.get(apiURLJS_Client)
    .pipe(map(res => {
      return JSON.parse(JSON.stringify(res)).map(js => {
        
              return new SearchJobSubjects(
  js.subject_id,
  js.job_id,
  js.subject_number,
  js.first_name,
  js.middle_name,
  js.surname,
  js.title,
  js.is_active,
  js.next_date,
  js.final_date,
  js.job_status_id,
  js.street_address,
  js.suburb,
  js.state,
  js. postcode,
  js.phone_h,
  js.email,
  js.dob,
  js.phone_m,
  js.subject_type_id,
  js.file_number,
  js.special_instructions,
  js.job_status,
  js.reference_number,
  js.job_reference_number,
  js.created_by,
  js.created_date,
  js.updated_date,
  js.updated_by,
  js.completed_date,
  js.completed_by,
  js.start_date,
  js.started_by,
  js.time_taken,
  js.sex,
  js.finalised,
  js.subject_reference_created,
  js.brand_report_user_id,
  js.job_type_id,
  js.job_type_location_id,
  js.job_type_court_id,
  js.job_type_document_type_id,
  js.job_type_affidavit_type_id,
  js.business_name,
  js.prev_subject_id,
  js.next_subject_id,
  js.number_subjects,
  js.existing_subjects_count,
  js.job_subject_type_id,
  js.subject_report_order_number,
  js.job_service_rule_id,
  js.job_service_timeframe_id,
  js.subject_service_type_id,
  js.service_company_name,
  js.service_directors_name,
  js.service_prison_name,
  js.service_law_firm_name,
  js.service_solicitor_name,
  js.owner_trace_code,
  js.subject_name,
  js.job_number,
  js.timeframe_surcharge_colour,
js.timeframe_surcharge_id,
js.timeframe_surcharge_icon,
js.timeframe_surcharge_name
              );
            });
          }));
  
    }
  


  filterSearchResults(js){
    if (this.gfunc.sessionUserLevel == 5) {
      let newArr = Object(js).filter((sbi)=>(sbi.brand_type_id == this.gfunc.sessionBrandId)); // User this if filter is needed.
       // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      // return newArr;
       //  this.js = newArr;
      // this.js = DataUtil.parse.parseJson(newArr);
      // this.grid.refresh();
      console.log('filtered Search f: ', DataUtil.parse.parseJson(newArr) );
      
      } else {
  // do nothing
  
        // this.subject_services_data = data;
        // this.brand_types_data = data;
        // this.grid.refresh();
      }
  }
  




  searchTBrand(term: string, brand_id: number): Observable<SearchTrace[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLTBrand = `${this.apiRootTBrand}/${term}/2002/${brand_id}/0/0`;
    return this._http.get(apiURLTBrand)
        .pipe(map(res => {
          return res[0].json().map(t => {
            return new SearchTrace(
                t.trace_id,
                t.trace_number,
                t.brand_id,
                t.client_company_name,
                t.client_name,
                t.client_phone,
                t.special_instructions,
                t.report_type_id,
                t.client_client_id,
                t.updated_by,
                t.created_date,
                t.creatded_by,
                t.created_by,
                t.owner_trace_code,
                t.updated_date,
                t.project_type,
                t.allocated_date,
                t.allocated_to,
                t.allocated_by,
                t.status,
                t.progress_percentage,
                t.locate_status,
                t.total_candidates_count,
                t.completed_candidates_count,
                t.completed_date,
                t.trace_api_key,
                t.pl_count,
                t.l_count,
                t.nl_count,
                t.fee,
                t.adverage_trace_time,
                t.total_open,
                t.total_all,
                t.total_all_all,
                t.pl_percent,
                t.l_percent,
                t.nl_percent,
                t.completed_by,
                t.start_date,
                t.started_by,
                t.time_taken,
                
                
            );
          });
        }));

  }



  searchTStaff(term: string, user_id: number): Observable<SearchTrace[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLTStaff = `${this.apiRootTStaff}/${term}/2002/${user_id}/0/0`;
    return this._http.get(apiURLTStaff)
        .pipe(map(res => {
          return res[0].json().map(t => {
            return new SearchTrace(
                t.trace_id,
                t.trace_number,
                t.brand_id,
                t.client_company_name,
                t.client_name,
                t.client_phone,
                t.special_instructions,
                t.report_type_id,
                t.client_client_id,
                t.updated_by,
                t.created_date,
                t.creatded_by,
                t.created_by,
                t.owner_trace_code,
                t.updated_date,
                t.project_type,
                t.allocated_date,
                t.allocated_to,
                t.allocated_by,
                t.status,
                t.progress_percentage,
                t.locate_status,
                t.total_candidates_count,
                t.completed_candidates_count,
                t.completed_date,
                t.trace_api_key,
                t.pl_count,
                t.l_count,
                t.nl_count,
                t.fee,
                t.adverage_trace_time,
                t.total_open,
                t.total_all,
                t.total_all_all,
                t.pl_percent,
                t.l_percent,
                t.nl_percent,
                t.completed_by,
                t.start_date,
                t.started_by,
                t.time_taken,

                
            );
          });
        }));

  }



  searchTC(term: string): Observable<SearchTraceCandidate[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLTC = `${this.apiRootTC}/${term}/202`;
    return this._http.get(apiURLTC)
        .pipe(map(res => {
          return res[0].json().map(tc => {
            return new SearchTraceCandidate(
                tc.trace_candidate_id,
                tc.candidate_firstname,
                tc.candidate_middlename,
                tc.candidate_surname,
                tc.candidate_dob_provided,
                tc.trace_id,
                tc.report_id,
                tc.owner_trace_code,
                tc.candidate_trace_number,
                tc.candidate_file_code,
                tc.special_instructions,
                tc.report_type_id,
                tc.updated_date,
                tc.updated_by,
                tc.created_date,
                tc.created_by,
                tc.allocated_date,
                tc.allocated_to,
                tc.allocated_by,
                tc.status,
                tc.progress_percentage,
                tc.locate_status,
                tc.total_candidates_count,
                tc.completed_candidates_count,
                tc.completed_date,
                tc.trace_api_key,
                tc.trace_number,
                tc.candidate_email,
                tc.brand_id,
                tc.completed_by,
                tc.client_client_id,
                tc.candidate_address,
                tc.start_date,
                tc.started_by,
                tc.time_taken


            );
          });
        }));

  }



  searchTCBrand(term: string, brand_id: number): Observable<SearchTraceCandidate[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLTCBrand = `${this.apiRootTCBrand}/${term}/2002/${brand_id}/0/0`;
    return this._http.get(apiURLTCBrand)
        .pipe(map(res => {
          return res[0].json().map(tc => {
            return new SearchTraceCandidate(
                tc.trace_candidate_id,
                tc.candidate_firstname,
                tc.candidate_middlename,
                tc.candidate_surname,
                tc.candidate_dob_provided,
                tc.trace_id,
                tc.report_id,
                tc.owner_trace_code,
                tc.candidate_trace_number,
                tc.candidate_file_code,
                tc.special_instructions,
                tc.report_type_id,
                tc.updated_date,
                tc.updated_by,
                tc.created_date,
                tc.created_by,
                tc.allocated_date,
                tc.allocated_to,
                tc.allocated_by,
                tc.status,
                tc.progress_percentage,
                tc.locate_status,
                tc.total_candidates_count,
                tc.completed_candidates_count,
                tc.completed_date,
                tc.trace_api_key,
                tc.trace_number,
                tc.candidate_email,
                tc.brand_id,
                tc.completed_by,
                tc.client_client_id,
                tc.candidate_address,
                tc.start_date,
                tc.started_by,
                tc.time_taken
            );
          });
        }));

  }









  searchTCStaff(term: string, user_id: number): Observable<SearchTraceCandidate[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLTCStaff = `${this.apiRootTCStaff}/${term}/2002/${user_id}/0/0`;
    return this._http.get(apiURLTCStaff)
        .pipe(map(res => {
          return res[0].json().map(tc => {
            return new SearchTraceCandidate(
                tc.trace_candidate_id,
                tc.candidate_firstname,
                tc.candidate_middlename,
                tc.candidate_surname,
                tc.candidate_dob_provided,
                tc.trace_id,
                tc.report_id,
                tc.owner_trace_code,
                tc.candidate_trace_number,
                tc.candidate_file_code,
                tc.special_instructions,
                tc.report_type_id,
                tc.updated_date,
                tc.updated_by,
                tc.created_date,
                tc.created_by,
                tc.allocated_date,
                tc.allocated_to,
                tc.allocated_by,
                tc.status,
                tc.progress_percentage,
                tc.locate_status,
                tc.total_candidates_count,
                tc.completed_candidates_count,
                tc.completed_date,
                tc.trace_api_key,
                tc.trace_number,
                tc.candidate_email,
                tc.brand_id,
                tc.completed_by,
                tc.client_client_id,
                tc.candidate_address,
                tc.start_date,
                tc.started_by,
                tc.time_taken
            );
          });
        }));

  }








  searchS(term: string): Observable<SearchTrace[]> {
    // const apiURLT = `${this.apiRootT}?term=${term}&limit=100`;
    const apiURLS = `${this.apiRootS}/${term}/10000/${term}/0/0`;
    return this._http.get(apiURLS)
        .pipe(map(res => {
          return res[0].json().map(t => {
            return new SearchTrace(
                t.trace_id,
                t.trace_number,
                t.brand_id,
                t.client_company_name,
                t.client_name,
                t.client_phone,
                t.special_instructions,
                t.report_type_id,
                t.client_client_id,
                t.updated_by,
                t.created_date,
                t.creatded_by,
                t.created_by,
                t.owner_trace_code,
                t.updated_date,
                t.project_type,
                t.allocated_date,
                t.allocated_to,
                t.allocated_by,
                t.status,
                t.progress_percentage,
                t.locate_status,
                t.total_candidates_count,
                t.completed_candidates_count,
                t.completed_date,
                t.trace_api_key,
                t.pl_count,
                t.l_count,
                t.nl_count,
                t.fee,
                t.adverage_trace_time,
                t.total_open,
                t.total_all,
                t.total_all_all,
                t.pl_percent,
                t.l_percent,
                t.nl_percent,
                t.completed_by,
                t.start_date,
                t.started_by,
                t.time_taken
            );
          });
        }));

  }







}

